module.exports = __webpack_public_path__ + "img/3.5a6aa431.png";